import _extends from "@babel/runtime/helpers/extends";import _slicedToArray from "@babel/runtime/helpers/slicedToArray";import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";var _excluded = ["delay", "size"];import { useIsMounted } from '../hooks/useIsMounted';
import React, { forwardRef, useEffect, useState } from 'react';
import { radius, svgSize } from './Loader.shared';
import { Loader_Root } from './Loader.styles';






export var Loader = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$delay =



    props.delay,delay = _props$delay === void 0 ? 200 : _props$delay,_props$size = props.size,size = _props$size === void 0 ? 5 : _props$size,otherProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),show = _useState2[0],setShow = _useState2[1];
  var isMounted = useIsMounted();

  useEffect(function () {
    var delayTimeout = setTimeout(function () {
      if (isMounted.current) {
        setShow(true);
      }
    }, delay);

    return function () {
      clearTimeout(delayTimeout);
    };
  }, [delay, isMounted]);

  return /*#__PURE__*/(
    React.createElement(Loader_Root, _extends({
      "aria-busy": "true",
      ref: ref,
      role: "alert",
      show: show,
      size: size },
    otherProps), /*#__PURE__*/

    React.createElement("svg", { viewBox: "0 0 ".concat(svgSize * 2, " ").concat(svgSize * 2) }, /*#__PURE__*/
    React.createElement("circle", {
      cx: svgSize,
      cy: svgSize,
      r: radius }
    )
    )
    ));

});

Loader.displayName = 'Loader';
//# sourceMappingURL=Loader.js.map